import { isDefined } from "@omni/utils/helper.utils";
import { createContext, ReactNode, use } from "react";

type PriceContextValue = {
    price: number;
    strikeThroughPrice?: number | null;
    conversionPrice?: number | null;
    conversionUnit?: string | null;
    size: "xs" | "sm" | "md" | "lg" | "xl";
};

type PriceContextProviderProps = {
    price: number;
    strikeThroughPrice?: number | null;
    conversionPrice?: number | null;
    conversionUnit?: string | null;
    size: "xs" | "sm" | "md" | "lg" | "xl";
    children: ReactNode;
};

export const PriceContext = createContext<PriceContextValue | undefined>(
    undefined
);
PriceContext.displayName = "PriceContext";

export const PriceContextProvider = ({
    price,
    strikeThroughPrice,
    conversionPrice,
    conversionUnit,
    size,
    children
}: PriceContextProviderProps) => {
    return (
        <PriceContext
            value={{
                price: price,
                strikeThroughPrice: strikeThroughPrice,
                conversionPrice: conversionPrice,
                conversionUnit: conversionUnit,
                size: size
            }}
        >
            {children}
        </PriceContext>
    );
};

export const usePriceContext = () => {
    const context = use<PriceContextValue | undefined>(PriceContext);

    if (!isDefined(context)) {
        throw new Error(`${PriceContext.displayName} is undefined.`);
    }

    return context;
};
